import axios from 'axios';
import config from '../config';

let configUrl = config.apiUrl;

// Функция для добавления нового трека
export const addTrack = async (track, status, date, userPhone = null, userId = null) => {
  try {
    const token = localStorage.getItem('token');
    const payload = {
      track,
      status,
      date
    };

    // Добавляем информацию о пользователе если указана
    if (userPhone) {
      payload.userPhone = userPhone;
    }
    if (userId) {
      payload.userId = userId;
    }

    const response = await axios.post(`${configUrl}/api/track/addTrack`, payload, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 400) {
      const { message, errors } = error.response.data;
      console.log('Validation errors:', errors);
      alert(message);
    } else {
      console.error('Error:', error.message);
    }
  }
};

// Функция для отправки запроса на обновление треков на сервер
export const excelTracks = async (tracks, status, date, userPhone = null) => {
  try {
      // Отправляем POST запрос на сервер для обновления треков
      const token = localStorage.getItem('token');
      const payload = {
          tracks,
          status,
          date
      };

      // Добавляем информацию о пользователе если указана
      if (userPhone) {
        payload.userPhone = userPhone;
      }

      const response = await axios.post(`${configUrl}/api/track/addExcelTrack`, payload, {
        headers: { Authorization: `Bearer ${token}` }
      });
      
      // Возвращаем данные ответа от сервера
      return response.data;
  } catch (error) {
    if (error.response && error.response.status === 400) {
      const { message, errors } = error.response.data;
      console.log('Validation errors:', errors);
      alert(message);
    } else {
      console.error('Error:', error.message);
    }
  }
};

// НОВАЯ ФУНКЦИЯ: Публичный поиск трека (без авторизации)
export const searchTrackPublic = async (trackNumber, phone = null, companyId = null) => {
  try {
    const params = { trackNumber };
    if (phone) params.phone = phone;
    if (companyId) params.companyId = companyId;

    const response = await axios.get(`${configUrl}/api/track/public/search`, { params });
    return response.data;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return { success: false, message: 'Track not found' };
    }
    console.error('Error searching track:', error.message);
    return { success: false, message: 'Error searching track' };
  }
};
